import { render, staticRenderFns } from "./ParameterOptions.vue?vue&type=template&id=23e987c0&"
import script from "./ParameterOptions.vue?vue&type=script&lang=ts&"
export * from "./ParameterOptions.vue?vue&type=script&lang=ts&"
import style0 from "./ParameterOptions.vue?vue&type=style&index=0&id=23e987c0&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports